import {React, styled} from 'common'
import DialogTitleRaw from '@mui/material/DialogTitle'
import {Colors, Texts} from 'appearance'
import {IconButton} from '@mui/material'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
const DialogTitle = ({title, onClose}) => {
    return (
        <DialogTitleRaw
            sx={{
                padding: 0,
            }}>
            <Container>
                <Title>{title}</Title>
                <IconButton onClick={onClose}>
                    <CloseButton />
                </IconButton>
            </Container>
        </DialogTitleRaw>
    )
}

export default DialogTitle

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 35px;
    background: ${Colors.primaryGradient};
`

const Title = styled(Texts.MainText)`
    padding: 0 10px;
`

const CloseButton = styled(CancelRoundedIcon)`
    &.hover {
        color: red;
    }
`
